import { Digtective } from '..';

export function updateAdCode(facade: Digtective, adCode?: string) {
  if (!adCode) return;
  const session = facade.getSession();
  if (session?.adCode && session.adCode !== adCode)
    return facade.updateSession({ adCode });
  return facade.updateSession({ adCode });
}
